import React from "react";
import ReactDOM from "react-dom/client";
// react library for routing
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.1";

import { NotificationProvider } from "components/CommonComponents/NotificationProvider";
import SkillVerification from "pages/SkillVerification";
import routes from "routes";

const root = ReactDOM.createRoot(document.getElementById("root"));

const App = () => {
  return (
    <Routes>
      <Route
        path="/skills-verification/:id?"
        element={<SkillVerification />}
      />
      {routes.map((r, idx) => (
        <Route key={idx} path={r.path} element={<r.component />} />
      ))}
      <Route
        path="*"
        element={<Navigate to="/skills-verification" replace />}
      />
    </Routes>
  );
};

root.render(
  <BrowserRouter>
    <NotificationProvider>
      <App />
    </NotificationProvider>
  </BrowserRouter>
);
